import React from 'react'

function About() {
    return (
        <div className="about-div">
            About
        </div>
    )
}

export default About
